import { Fields } from './types';

export const useDefaultValues = (): Fields => {
  return {
    onetimeCode: '',
  };
};
